module.exports = __webpack_public_path__ + "static/media/024.d863179d.jpg";